import cx from 'classnames'
import { navigate } from 'gatsby'
import React from 'react'

import Spinner from '@cinch/oxd-components/loading-spinner/src'

import HeaderIconComponent, { Theme } from '@cinch/oxd-components/header-icon/src'
import ProfileAvatar from './components/profile-avatar'
import * as styles from './profile-link.module.css'

const SPINNER_SIZE = 30

const AuthActions: React.FC<{
  isPending: boolean
  isAuthenticated: boolean
  theme?: Theme
  isInverted?: boolean
  image?: string
  name?: string
  i18n?: any
}> = ({
  isPending = false,
  isAuthenticated = false,
  isInverted = false,
  image = '',
  name = '',
  i18n = { title: 'My profile' },
  theme,
}) => {
  const label =
    !isPending && isAuthenticated && name
      ? `Hi ${name}!`
      : !isPending && isAuthenticated && !name
      ? 'Profile'
      : !isPending && i18n.title

  const Authenticated = () => (
    <span className={styles.greeting}>
      <div className={styles.buttonContent}>{label}</div>
      <ProfileAvatar isAuthenticated={true} image={image} />
    </span>
  )

  const Anonymous = () => (
    <span className={styles.greeting}>
      <div className={styles.buttonContent}>{label}</div>
      <ProfileAvatar isAuthenticated={false} />
    </span>
  )

  return (
    <div className={cx(styles.actions, { [styles.inverted]: isInverted })}>
      <HeaderIconComponent
        onClick={() => navigate('/my-profile')}
        tabIndex={-1}
        theme={theme ? theme : isInverted ? Theme.dark : Theme.light}
        label={label}
      >
        <>
          {isAuthenticated && !isPending && <Authenticated />}
          {!isAuthenticated && !isPending && <Anonymous />}
          {isPending && <Spinner size={SPINNER_SIZE} />}
        </>
      </HeaderIconComponent>
    </div>
  )
}

export default AuthActions
